import { HospitalInfoResponseDto } from "@/data/dto/hospital-info-reponse-dto";
import { HospitalInfoEntity } from "@/domain/entity/hospital-info-entity";
import { assertHospitalInfoResponseDto } from "@/utils/validation/generated/hospital-info-response-dto.validator";

export class HospitalInfoMapper {
  static toEntity(dto: HospitalInfoResponseDto): HospitalInfoEntity {
    assertHospitalInfoResponseDto(dto);

    return {
      name: dto.hospitalName,
      code: dto.hospitalCode,
      doctorRegisterCount: dto.doctorRegisterCount ?? 0,
      patientRegisterCount: dto.patientRegisterCount ?? 0,
    };
  }

  static toEntityList(dto: HospitalInfoResponseDto[]): HospitalInfoEntity[] {
    return dto.map((item) => HospitalInfoMapper.toEntity(item));
  }
}
